import Dashboard from "@/common/components/layout/Dashboard"
import Toast from "@/common/components/ui/toast"
import { ToastProvider } from "@/common/components/ui/toast/toast.provider"
import TableLoans from "./components/table/TableLoan"

function LoanRegisterPage() {
  return (
    <ToastProvider>
      <Dashboard>
        <TableLoans />
      </Dashboard>
      <Toast />
    </ToastProvider>
  )
}

export default LoanRegisterPage